/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import validationInformationsNaissance from '../validationInformationsNaissance';

/**
 * Validation de l'étape « Enfant » pour la reconnaissance : état civil de
 * l'enfant, SANS lieu de naissance (décision 2) et avec les assouplissements
 * de la décision 8 pour le sous-type « Avant la naissance » (`N`).
 *
 * Extraite de `validationStep1Reconnaissance` : l'enfant a désormais sa
 * propre étape, avant celle des parents.
 */
const validationStepEnfantReconnaissance = (data: Record<string, any>) => {
  // Sous-type « Avant la naissance » : reconnaissance prénatale, l'enfant
  // n'est pas encore né au moment de l'acte (décision produit 8).
  const prenatal = data?.codeSousTypeActe === 'N';

  return validationInformationsNaissance(data, false, false, undefined, {
    // Pas de bloc « Lieu de naissance » pour l'enfant en reconnaissance
    // (décision 2) : toujours désactivé, quel que soit le sous-type.
    controleLieuNaissance: false,
    enfantNonNe: prenatal,
  });
};

export default validationStepEnfantReconnaissance;
